module.exports = __webpack_public_path__ + "img/logo1 (32).aa641ebe.jpg";